import { render, staticRenderFns } from "./EmiManager.vue?vue&type=template&id=164bc8f3"
import script from "./EmiManager.vue?vue&type=script&lang=js"
export * from "./EmiManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports